const STATS = [
  { num: 'Unlimited', lab: 'Tokens' },
  { num: 'Unlimited', lab: 'Context window' },
  { num: 'Sovereign-grade', lab: 'Zero retention · zero training' },
]

export default function ProofBar() {
  return (
    <div className="border-b border-[var(--line)] py-12">
      <div className="mx-auto max-w-[1080px] px-7">
        <div className="lg:grid lg:grid-cols-[160px_minmax(0,1fr)] lg:gap-x-16">
          <div className="mb-8 font-mono text-[11.5px] tracking-[0.14em] text-[var(--faint)] uppercase lg:mb-0 lg:pt-1.5">
            The meter is gone
          </div>
          <div className="grid grid-cols-1 gap-x-12 gap-y-8 sm:grid-cols-3">
            {STATS.map((s) => (
              <div key={s.lab}>
                <div className="text-[1.5rem] leading-[1.15] font-medium tracking-[-0.03em] text-[var(--ink)]">
                  {s.num}
                </div>
                <div className="mt-2 text-[0.95rem] leading-[1.5] text-[var(--muted)]">{s.lab}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
